import useCurrentViewerVaspDID from "../useCurrentViewerVaspDID";

import { ViewerPermissions } from "~/contexts/ViewerContext";
import useCurrentViewer from "~/hooks/useCurrentViewer";
import useAuth from "~/utils/useAuth";

export default function useCurrentViewerPermissions(billingCustomerDid?: string, vaspDid?: string) {
  const { viewer: currentViewer } = useCurrentViewer();
  const { isNotabeneAdmin } = useAuth();
  const vaspDID = useCurrentViewerVaspDID() || vaspDid;

  if (isNotabeneAdmin) {
    return [ViewerPermissions["trustframework.getVASP"], ViewerPermissions["trustframework.listVASP"]];
  }

  const hasRoles = currentViewer.roles.length > 0;

  const billingCustomerPermissions =
    hasRoles && billingCustomerDid
      ? currentViewer.roles.find((role) => role.billingCustomerDid && role.billingCustomerDid === billingCustomerDid)
          ?.permissions || []
      : [];

  if (billingCustomerPermissions.length > 0) {
    return billingCustomerPermissions;
  }

  const vaspPermissions =
    hasRoles && vaspDID
      ? currentViewer.roles.find((role) => role.vaspDID && role.vaspDID === vaspDID)?.permissions || []
      : [];

  return vaspPermissions;
}
